export default function () {
    return {};
}


// WEBPACK FOOTER //
// ./src/loadInitialState.js